module.exports = __webpack_public_path__ + "img/order-process-image-03.133210d.svg";